@if (linkedEducatorContext.duplicateEducators && linkedEducatorContext.duplicateEducators.length > 0) {
  <a class="text-primary icon-hover" [certTooltip]="getDuplicateEducatorText()" (click)="openLinkedEducatorsModal()"
    ><i class="bi bi-link-45deg"></i
  ></a>
}
